export interface PhotoItem {
  id: string;
  deviceNo: string;
  deviceId: string;
  thumbnailUrl: string;
  fullUrl: string;
  latitude: number;
  longitude: number;
  altitude: number;
  locationName: string;
  takenAt: string;
  fileSize: string;
  resolution: string;
  category: "scenery" | "selfie" | "group" | "ar_sticker" | "recognition";
  syncStatus: "synced" | "pending" | "failed";
  recognitionResult?: {
    sceneName: string;
    confidence: number;
    tags: string[];
    recognizedAt: string;
  } | null;
  stickerInfo?: {
    stickerName: string;
    stickerType: string;
  } | null;
}

export const photoStats = {
  total: 2847,
  todayNew: 156,
  synced: 2712,
  pending: 98,
  failed: 37,
  withRecognition: 1845,
};

export const photoCategories = [
  { label: "全部分类", value: "all", count: 2847 },
  { label: "风景拍摄", value: "scenery", count: 1024 },
  { label: "自拍合影", value: "selfie", count: 683 },
  { label: "团体合影", value: "group", count: 412 },
  { label: "AR 贴纸", value: "ar_sticker", count: 389 },
  { label: "AI 识别", value: "recognition", count: 339 },
];

export const photos: PhotoItem[] = [
  {
    id: "p001",
    deviceNo: "A001",
    deviceId: "1",
    thumbnailUrl: "/assets/img/75211c63bb43227b.jpg",
    fullUrl: "/assets/img/daee68e338b3cfe2.jpg",
    latitude: 30.8235,
    longitude: 111.0037,
    altitude: 185,
    locationName: "三峡大坝",
    takenAt: "2026-06-09 10:23:15",
    fileSize: "2.4 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "三峡大坝",
      confidence: 0.97,
      tags: ["三峡大坝", "泄洪", "水利工程", "长江"],
      recognizedAt: "2026-06-09 10:23:18",
    },
  },
  {
    id: "p002",
    deviceNo: "A002",
    deviceId: "2",
    thumbnailUrl: "/assets/img/d4da397cd8c85757.jpg",
    fullUrl: "/assets/img/2af11fec81cc03ac.jpg",
    latitude: 30.8012,
    longitude: 110.9887,
    altitude: 220,
    locationName: "黄牛岩",
    takenAt: "2026-06-09 10:35:42",
    fileSize: "1.8 MB",
    resolution: "3024x4032",
    category: "selfie",
    syncStatus: "synced",
  },
  {
    id: "p003",
    deviceNo: "A004",
    deviceId: "4",
    thumbnailUrl: "/assets/img/3e8248ca0b664042.jpg",
    fullUrl: "/assets/img/2496e14a1d129277.jpg",
    latitude: 30.7856,
    longitude: 110.9723,
    altitude: 95,
    locationName: "西陵峡口",
    takenAt: "2026-06-09 10:48:10",
    fileSize: "3.1 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "西陵峡口",
      confidence: 0.94,
      tags: ["西陵峡", "峡谷", "长江", "游船"],
      recognizedAt: "2026-06-09 10:48:13",
    },
  },
  {
    id: "p004",
    deviceNo: "A008",
    deviceId: "8",
    thumbnailUrl: "/assets/img/dc8327ce6ffd278c.jpg",
    fullUrl: "/assets/img/bd04c1ba2136a758.jpg",
    latitude: 30.7365,
    longitude: 111.2789,
    altitude: 72,
    locationName: "葛洲坝",
    takenAt: "2026-06-09 11:12:33",
    fileSize: "2.9 MB",
    resolution: "4032x3024",
    category: "group",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "葛洲坝",
      confidence: 0.91,
      tags: ["葛洲坝", "合影", "水利"],
      recognizedAt: "2026-06-09 11:12:36",
    },
  },
  {
    id: "p005",
    deviceNo: "A003",
    deviceId: "3",
    thumbnailUrl: "/assets/img/e39f9cda4fedae76.jpg",
    fullUrl: "/assets/img/b54631fcf734cb96.jpg",
    latitude: 30.8235,
    longitude: 111.0037,
    altitude: 185,
    locationName: "三峡大坝",
    takenAt: "2026-06-09 11:25:08",
    fileSize: "1.5 MB",
    resolution: "3024x4032",
    category: "ar_sticker",
    syncStatus: "synced",
    stickerInfo: {
      stickerName: "鲟侠船长",
      stickerType: "角色贴纸",
    },
  },
  {
    id: "p006",
    deviceNo: "A011",
    deviceId: "11",
    thumbnailUrl: "/assets/img/4309ccd6c4ce2424.jpg",
    fullUrl: "/assets/img/7e6be3c786989b90.jpg",
    latitude: 30.7723,
    longitude: 111.1547,
    altitude: 156,
    locationName: "三游洞",
    takenAt: "2026-06-09 11:38:55",
    fileSize: "2.7 MB",
    resolution: "4032x3024",
    category: "recognition",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "三游洞",
      confidence: 0.88,
      tags: ["三游洞", "石刻", "古迹", "洞穴"],
      recognizedAt: "2026-06-09 11:38:58",
    },
  },
  {
    id: "p007",
    deviceNo: "A001",
    deviceId: "1",
    thumbnailUrl: "/assets/img/938494bc7bb71bd1.jpg",
    fullUrl: "/assets/img/ecbf24c4ce373db0.jpg",
    latitude: 30.9912,
    longitude: 110.6954,
    altitude: 68,
    locationName: "秭归港",
    takenAt: "2026-06-09 09:15:22",
    fileSize: "2.1 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "秭归港",
      confidence: 0.93,
      tags: ["秭归港", "港口", "清晨", "渔船"],
      recognizedAt: "2026-06-09 09:15:25",
    },
  },
  {
    id: "p008",
    deviceNo: "A005",
    deviceId: "5",
    thumbnailUrl: "/assets/img/4bf85a3bee82e11e.jpg",
    fullUrl: "/assets/img/965c2920a047551b.jpg",
    latitude: 30.8012,
    longitude: 110.9887,
    altitude: 220,
    locationName: "黄牛岩",
    takenAt: "2026-06-09 11:52:40",
    fileSize: "1.6 MB",
    resolution: "3024x4032",
    category: "ar_sticker",
    syncStatus: "pending",
    stickerInfo: {
      stickerName: "金鲤跃龙门",
      stickerType: "特效贴纸",
    },
  },
  {
    id: "p009",
    deviceNo: "A014",
    deviceId: "14",
    thumbnailUrl: "/assets/img/bf1c8460e88d4329.jpg",
    fullUrl: "/assets/img/3fd99e2a62db16e9.jpg",
    latitude: 30.7621,
    longitude: 111.1356,
    altitude: 245,
    locationName: "石牌要塞",
    takenAt: "2026-06-09 12:05:18",
    fileSize: "3.4 MB",
    resolution: "4032x3024",
    category: "recognition",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "石牌要塞",
      confidence: 0.95,
      tags: ["石牌要塞", "抗战", "军事", "历史遗迹"],
      recognizedAt: "2026-06-09 12:05:21",
    },
  },
  {
    id: "p010",
    deviceNo: "A012",
    deviceId: "12",
    thumbnailUrl: "/assets/img/0e291c999d173ebd.jpg",
    fullUrl: "/assets/img/284f41eb07a5387c.jpg",
    latitude: 30.9956,
    longitude: 110.6988,
    altitude: 72,
    locationName: "屈原故里",
    takenAt: "2026-06-09 12:18:34",
    fileSize: "2.5 MB",
    resolution: "4032x3024",
    category: "group",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "屈原故里",
      confidence: 0.89,
      tags: ["屈原故里", "祠堂", "文化", "合影"],
      recognizedAt: "2026-06-09 12:18:37",
    },
  },
  {
    id: "p011",
    deviceNo: "A020",
    deviceId: "20",
    thumbnailUrl: "/assets/img/28f4ee6f8bc051d1.jpg",
    fullUrl: "/assets/img/d99cea35d806c2cd.jpg",
    latitude: 30.8856,
    longitude: 111.2234,
    altitude: 310,
    locationName: "太平溪",
    takenAt: "2026-06-09 12:32:10",
    fileSize: "3.8 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "pending",
  },
  {
    id: "p012",
    deviceNo: "A002",
    deviceId: "2",
    thumbnailUrl: "/assets/img/15adddeb26fa0311.jpg",
    fullUrl: "/assets/img/807e7174f356878a.jpg",
    latitude: 30.7556,
    longitude: 111.1467,
    altitude: 168,
    locationName: "南津关",
    takenAt: "2026-06-09 12:45:29",
    fileSize: "2.3 MB",
    resolution: "3024x4032",
    category: "recognition",
    syncStatus: "failed",
    recognitionResult: {
      sceneName: "南津关",
      confidence: 0.76,
      tags: ["南津关", "摩崖石刻", "古诗"],
      recognizedAt: "2026-06-09 12:45:32",
    },
  },
  {
    id: "p013",
    deviceNo: "A001",
    deviceId: "1",
    thumbnailUrl: "/assets/img/52b7f6952c2db1e8.jpg",
    fullUrl: "/assets/img/b8cb460981011eee.jpg",
    latitude: 30.8235,
    longitude: 111.0037,
    altitude: 185,
    locationName: "三峡大坝",
    takenAt: "2026-06-09 13:01:45",
    fileSize: "1.9 MB",
    resolution: "3024x4032",
    category: "ar_sticker",
    syncStatus: "synced",
    stickerInfo: {
      stickerName: "蝶舞三峡",
      stickerType: "滤镜贴纸",
    },
  },
  {
    id: "p014",
    deviceNo: "A008",
    deviceId: "8",
    thumbnailUrl: "/assets/img/a08a822542ae2b4a.jpg",
    fullUrl: "/assets/img/e333759e07efce12.jpg",
    latitude: 30.7856,
    longitude: 110.9723,
    altitude: 95,
    locationName: "西陵峡口",
    takenAt: "2026-06-09 13:15:08",
    fileSize: "3.6 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "西陵峡口",
      confidence: 0.96,
      tags: ["西陵峡口", "日落", "长江", "晚霞"],
      recognizedAt: "2026-06-09 13:15:11",
    },
  },
  {
    id: "p015",
    deviceNo: "A003",
    deviceId: "3",
    thumbnailUrl: "/assets/img/ef000bf2a98dbb48.jpg",
    fullUrl: "/assets/img/05fdb5833a9bbb16.jpg",
    latitude: 30.7365,
    longitude: 111.2789,
    altitude: 72,
    locationName: "葛洲坝",
    takenAt: "2026-06-09 13:28:33",
    fileSize: "2.6 MB",
    resolution: "4032x3024",
    category: "selfie",
    syncStatus: "synced",
    recognitionResult: {
      sceneName: "葛洲坝",
      confidence: 0.92,
      tags: ["葛洲坝", "船闸", "合影"],
      recognizedAt: "2026-06-09 13:28:36",
    },
  },
  {
    id: "p016",
    deviceNo: "A013",
    deviceId: "13",
    thumbnailUrl: "/assets/img/2de26dbd4c18d9bc.jpg",
    fullUrl: "/assets/img/4d9571e46372f295.jpg",
    latitude: 30.9912,
    longitude: 110.6954,
    altitude: 68,
    locationName: "秭归港",
    takenAt: "2026-06-09 09:05:12",
    fileSize: "2.8 MB",
    resolution: "4032x3024",
    category: "scenery",
    syncStatus: "pending",
  },
];

export interface RecognitionTask {
  id: string;
  photoId: string;
  sceneName: string;
  confidence: number;
  tags: string[];
  status: "processing" | "completed" | "failed";
  createdAt: string;
  completedAt: string | null;
  deviceNo: string;
}

export const recognitionTasks: RecognitionTask[] = [
  {
    id: "r001",
    photoId: "p001",
    sceneName: "三峡大坝",
    confidence: 0.97,
    tags: ["三峡大坝", "泄洪", "水利工程", "长江"],
    status: "completed",
    createdAt: "2026-06-09 10:23:15",
    completedAt: "2026-06-09 10:23:18",
    deviceNo: "A001",
  },
  {
    id: "r002",
    photoId: "p003",
    sceneName: "西陵峡口",
    confidence: 0.94,
    tags: ["西陵峡", "峡谷", "长江", "游船"],
    status: "completed",
    createdAt: "2026-06-09 10:48:10",
    completedAt: "2026-06-09 10:48:13",
    deviceNo: "A004",
  },
  {
    id: "r003",
    photoId: "p004",
    sceneName: "葛洲坝",
    confidence: 0.91,
    tags: ["葛洲坝", "合影", "水利"],
    status: "completed",
    createdAt: "2026-06-09 11:12:33",
    completedAt: "2026-06-09 11:12:36",
    deviceNo: "A008",
  },
  {
    id: "r004",
    photoId: "p006",
    sceneName: "三游洞",
    confidence: 0.88,
    tags: ["三游洞", "石刻", "古迹", "洞穴"],
    status: "completed",
    createdAt: "2026-06-09 11:38:55",
    completedAt: "2026-06-09 11:38:58",
    deviceNo: "A011",
  },
  {
    id: "r005",
    photoId: "p007",
    sceneName: "秭归港",
    confidence: 0.93,
    tags: ["秭归港", "港口", "清晨", "渔船"],
    status: "completed",
    createdAt: "2026-06-09 09:15:22",
    completedAt: "2026-06-09 09:15:25",
    deviceNo: "A001",
  },
  {
    id: "r006",
    photoId: "p009",
    sceneName: "石牌要塞",
    confidence: 0.95,
    tags: ["石牌要塞", "抗战", "军事", "历史遗迹"],
    status: "completed",
    createdAt: "2026-06-09 12:05:18",
    completedAt: "2026-06-09 12:05:21",
    deviceNo: "A014",
  },
  {
    id: "r007",
    photoId: "p010",
    sceneName: "屈原故里",
    confidence: 0.89,
    tags: ["屈原故里", "祠堂", "文化", "合影"],
    status: "completed",
    createdAt: "2026-06-09 12:18:34",
    completedAt: "2026-06-09 12:18:37",
    deviceNo: "A012",
  },
  {
    id: "r008",
    photoId: "p012",
    sceneName: "南津关",
    confidence: 0.76,
    tags: ["南津关", "摩崖石刻", "古诗"],
    status: "failed",
    createdAt: "2026-06-09 12:45:29",
    completedAt: null,
    deviceNo: "A002",
  },
  {
    id: "r009",
    photoId: "p015",
    sceneName: "葛洲坝",
    confidence: 0.92,
    tags: ["葛洲坝", "船闸", "合影"],
    status: "completed",
    createdAt: "2026-06-09 13:28:33",
    completedAt: "2026-06-09 13:28:36",
    deviceNo: "A003",
  },
  {
    id: "r010",
    photoId: "p014",
    sceneName: "西陵峡口",
    confidence: 0.96,
    tags: ["西陵峡口", "日落", "长江", "晚霞"],
    status: "completed",
    createdAt: "2026-06-09 13:15:08",
    completedAt: "2026-06-09 13:15:11",
    deviceNo: "A008",
  },
  {
    id: "r011",
    photoId: "p011",
    sceneName: "太平溪",
    confidence: 0.85,
    tags: ["太平溪", "观景台", "全景"],
    status: "processing",
    createdAt: "2026-06-09 12:32:10",
    completedAt: null,
    deviceNo: "A020",
  },
  {
    id: "r012",
    photoId: "p016",
    sceneName: "秭归港",
    confidence: 0.87,
    tags: ["秭归港", "晨雾", "渔船"],
    status: "processing",
    createdAt: "2026-06-09 09:05:12",
    completedAt: null,
    deviceNo: "A013",
  },
];

export const recognitionStats = {
  totalTasks: 2847,
  completed: 2638,
  processing: 125,
  failed: 84,
  avgConfidence: 0.91,
  avgProcessTime: "1.8s",
};